export default function validateMobile(rule, value, callback) {
  if (value.trim() === '') {
    callback(new Error('请输入手机号'))
  } else {
    if (!/^1[3456789]\d{9}$/.test(value.trim())) {
      callback(new Error('手机号格式不正确'))
    } else {
      callback()
    }
  }
}
